import React from 'react';
import { useLanguage } from 'src/hooks';
import { useAppDispatch } from 'src/store';
import { logoutAction } from 'src/services/auth';
import { Button } from 'src/components/general';
import accessDeniedIcon from 'src/icons/accessDenied.svg';
import styles from './accessDeniedStyle.module.scss';

export const AccessDenied = () => {
  const dispatch = useAppDispatch();
  const { t } = useLanguage();

  return (
    <div className={styles.container}>
      <img src={accessDeniedIcon} alt="" className={styles.img} />
      <div className={styles.label}>{t('page.accessDenied.title')}</div>
      <div className={styles.description}>
        {t('page.accessDenied.description')}
      </div>
      <Button
        label={t('general.logout')}
        onClick={() => {
          dispatch(logoutAction());
        }}
        design="outline"
      />
    </div>
  );
};

export default AccessDenied;
